import {
  TrackSelectionRedesignData,
  TrackSelectionRedesignVariant,
  TrackSelectionRedesignTestResult,
  UseTrackSelectionRedesign,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "trackSelectionPageRedesign";

/**
 * Hook for the track selection redesign experiment.
 * This experiment can return variants:
 * - horizontal: New design
 * - vertical: Original design
 */
const useTrackSelectionRedesign: UseTrackSelectionRedesign = (params = {}) => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: TrackSelectionRedesignData;
  }>(CUSTOM_RULE_ID, params);

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as TrackSelectionRedesignTestResult;
  }

  // Determine the variant based on the returned data
  const variant: TrackSelectionRedesignVariant =
    value.data.layout || "vertical";

  // Extract data for the experiment
  const data: TrackSelectionRedesignData = {
    title: value.data.title,
    subtitle: value.data.subtitle,
    showCourseNameInSubtitle: value.data.showCourseNameInSubtitle,
    layout: value.data.layout,
    auditCourse: value.data.auditCourse,
    horizontalLayoutFields: value.data.horizontalLayoutFields,
    cta: value.data.cta,
    promoBanner: value.data.promoBanner,
    testimonial: value.data.testimonial,
    verticalComparisonItems: value.data.verticalComparisonItems,
    isMobileVerticalComparisonStacked:
      value.data.isMobileVerticalComparisonStacked,
    programTrack: value.data.programTrack,
    mobileVerticalComparisonDefaultSlide:
      value.data.mobileVerticalComparisonDefaultSlide,
    abandonedUserModal: value.data.abandonedUserModal,
    subscriptionBox: value.data.subscriptionBox,
    bundleSavingsBanner: value.data.bundleSavingsBanner,
  };

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant,
    data,
  };
};

export default useTrackSelectionRedesign;
